var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeActivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57336 1.4691C8.38714 1.29762 8.10214 1.29238 7.90974 1.45689L1.67507 6.78773C1.56397 6.88273 1.5 7.02158 1.5 7.16776V14.5002C1.5 14.7763 1.72386 15.0002 2 15.0002H5.16667V12.6611C5.16667 11.0963 6.43519 9.82777 8 9.82777C9.56481 9.82777 10.8333 11.0963 10.8333 12.6611V15.0002H14C14.2761 15.0002 14.5 14.7763 14.5 14.5002V7.14565C14.5 7.00589 14.4415 6.8725 14.3387 6.77783L8.57336 1.4691ZM7.25987 0.696841C7.83708 0.203311 8.69207 0.219039 9.25074 0.733461L15.0161 6.04219C15.3245 6.32621 15.5 6.72636 15.5 7.14565V14.5002C15.5 15.3286 14.8284 16.0002 14 16.0002H9.83333V12.6611C9.83333 11.6486 9.01252 10.8278 8 10.8278C6.98748 10.8278 6.16667 11.6486 6.16667 12.6611V16.0002H2C1.17157 16.0002 0.5 15.3286 0.5 14.5002V7.16776C0.5 6.72923 0.6919 6.31267 1.0252 6.02768L7.25987 0.696841Z",
    fill: "#002EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActivo);
export default __webpack_public_path__ + "static/media/home-activo.b3f6c32efad0c308cbff1e186f2ffc55.svg";
export { ForwardRef as ReactComponent };